import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Form, TextArea, Segment, Container, Loader } from 'semantic-ui-react';
import { toast } from 'react-toastify';
import { fetchAutoSummary } from '../../actions/summary';
import { SummaryEditor } from '..';
import './AutoSummary.css';

class AutoSummary extends Component {
  constructor(props) {
    super(props);
    this.state = {
      editing: false,
      autoSummaryText: '',
    };
  }

  componentWillMount() {
    this.props.fetchAutoSummary(this.props.brandId);
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.autoSummary !== this.props.autoSummary) {
      if (nextProps.autoSummary.error) {
        toast.error(nextProps.autoSummary.error.toString());
      }
      if (!nextProps.autoSummary.isLoading) {
        const text = nextProps.autoSummary.summary.text;
        this.setState({
          autoSummaryText: text,
        });
      }
      this.setState({
        isLoading: nextProps.autoSummary.isLoading,
      });
    }
  }

  handleSave(text) {
    this.props.onSave(text);
    this.setState({ editing: false });
  }

  startEditor() {
    this.setState({
      editing: true,
    });
  }

  cancelEditor() {
    this.setState({
      editing: false,
    });
  }

  saveEditedAS() {
    console.log('should save to API');
    this.setState({
      editing: false,
    });
    this.props.onReady(this.state.editedSummary);
  }

  render() {
    return (
      <div className='autoSummary'>
        <h5>Automated Summary</h5>
        <Form>
          {this.state.isLoading
            ? <Loader active>Loading</Loader>
            : <TextArea rows={8} readOnly value={this.state.autoSummaryText} />
          }
        </Form>
        {!this.state.editing && (
          <div className='button-block'>
            <h5>Do you want to edit Auto Summary?</h5>
            <button onClick={() => this.props.onCancel()}>Cancel</button>
            <button onClick={() => this.handleSave(this.state.autoSummaryText)}>
              No, Save Automated Summary
            </button>
            <button onClick={() => this.startEditor()}>Yes</button>
          </div>
        )}
        {this.state.editing && (
          <SummaryEditor
            title='Summary Editor'
            originalText={ this.state.autoSummaryText }
            onSave={ text => this.handleSave(text) }
            onCancel={ () => this.props.onCancel() }
            onSaveAndNext={ newSummary => this.props.onSaveAndNext(newSummary) }
          >
          </SummaryEditor>
        )}
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    autoSummary: state.autoSummary,
  };
}

export default connect(mapStateToProps, { fetchAutoSummary })(AutoSummary);



// WEBPACK FOOTER //
// ./src/components/autoSummary/AutoSummary.js